const init = () => {
    
    var $bookSeries = $('.book-series');
    if ($bookSeries.length < 1) return;
    var $container = $bookSeries.find('.component__container');
    var $loadMore = $bookSeries.find('.book-series__load-more');
    var state;
    var itemsPerPage = $container.children().length;

    PubSub.subscribe('app:ready', function() {
        state = {
            p: window.app.state.urlParams.p || 1
        }
    });

    $loadMore.click(function() {
        if ($loadMore.hasClass('is-disabled')) return;
        if ($loadMore[0].hasAttribute('href')) return;
        $loadMore.addClass('is-loading');
        state.p ++;
        var url = (window.location.toString()).split('?p=')[0];
        var jqXhr = $.get(url, state)
            .done(function(data, textStatus, jqXhr) {
                var $data = $(data);
                var $newItems = $data.filter('.book-series').find('.book-series__container');
                $loadMore.removeClass('is-loading');
                
                if ($newItems.length < 1) {
                    $loadMore.addClass('is-disabled');
                } else {
                    $container.append($newItems);

                    if ($newItems.length < itemsPerPage) {
                        $loadMore.addClass('is-disabled');
                    }

                    // Trigger lazy loading migration for new content
                    setTimeout(function() {
                        if (window.app && window.app.migrateBlazy) {
                            window.app.migrateBlazy();
                        }
                    }, 0);
                }
            })
            .fail(function() {
                $loadMore.removeClass('is-loading');
            })
            .always(function() {
            });
    });
}

export default init;
